export const SEARCH_PANEL_BRAND_CHANGE = 'SEARCH_PANEL_BRAND_CHANGE';
export const SEARCH_PANEL_OPEN_FLYOUT = 'OPEN_FLYOUT';
export const SEARCH_PANEL_CLOSE_FLYOUT = 'CLOSE_FLYOUT';
export const HEADER_STATE_CHANGE = 'HEADER_STATE_CHANGE';
export const VAA_LOCALE_CHANGE = 'VAA_LOCALE_CHANGE';

export function subscribe(
  eventName: string,
  listener: (e: CustomEvent) => void,
) {
  document.addEventListener(eventName, listener as EventListener);
}

export function unsubscribe(
  eventName: string,
  listener: (e: CustomEvent) => void,
) {
  document.removeEventListener(eventName, listener as EventListener);
}

export function publish<T>(eventName: string, data: T) {
  const event = new CustomEvent<T>(eventName, { detail: data });
  document.dispatchEvent(event);
}
